import React from "react";
import { HotspotDetailImage } from "./HotspotDetailImage";

export default ({ imageX, imageY, imageSrc, selectedIcon }) => (
  <>
    <HotspotDetailImage
      backgroundImage={imageSrc}
      detailImage={selectedIcon.info.detailimage}
      positionX={imageX}
      positionY={imageY}
    />
    <div className="py-3">
      <p className="font-weight-bold text-primary">{selectedIcon.info.title}</p>
      <p>{selectedIcon.info.description}</p>
    </div>
  </>
);
